let lastAddStockFunction = null;

function addBannerAndRotationControls(bannerText, rotateControlsPosition, bannerPosition, fontSize, intervalControlPosition) {
  const mainChartTitle = document.querySelector("#main-container .title-and-date h2");
  if (mainChartTitle) {
    mainChartTitle.innerText = bannerText;
  }
}

const stockVisualizations = {
  addStockGainersToCenterPanel: ["stock-3d-cube", "top-gainers", "0 -0.3 .5", "0.95 0.95 0.95", "Top Gainers Percentage", "30 0 0", 2, 2, 2],
  addStockLosersToCenterPanel: ["stock-3d-cube", "top-losers", "0 0.3 .5", "0.95 0.95 0.95", "Top Losers Percentage", "30 0 0", 2, 2, 2],
  addStockGainersSectorToCenterPanel: ["stock-3d-cube", "top-gainers-sec", "0 -0.3 .5", "0.95 0.95 0.95", "Top Gainers Percentage by Sector", "30 0 0", 2, 2, 2],
  addStockLosersSectorToCenterPanel: ["stock-3d-cube", "top-losers-sec", "0 0.3 .5", "0.95 0.95 0.95", "Top Losers Percentage by Sector", "30 0 0", 2, 2, 2],
  addStockByVolCubeToCenterPanel: ["stock-3d-cube", "top-vol-sec", "0 -0.3 .5", "0.95 0.95 0.95", "Top Volume Movers by Sector - # of Shares", "30 0 0", 2, 2, 2],
  addStockByVolRankCubeToCenterPanel: ["stock-3d-cube", "top-vol", "0 -0.3 .5", "0.95 0.95 0.95", "Top Volume Movers - # of Shares", "30 0 0", 2, 2, 2],
  addStockTopDollarSectorCubeToCenterPanel: ["stock-3d-cube", "top-dollar-vol-sec", "0 0 .5", "0.95 0.95 0.95", "Top Total $ Volume by Sector - Price % Change", "30 0 0", 2, 2, 2],
  addStockTopDollarCubeToCenterPanel: ["stock-3d-cube", "top-dollar-vol", "0 0 .5", "0.95 0.95 0.95", "Top Total $ Volume - Price % Change", "30 0 0", 2, 2, 2],
  addMarketMapCubeToCenterPanel: ["stock-3d-cube", "mmap", "0 0 .5", "0.95 0.95 0.95", "Market Map (S&P500)", "30 0 0", 2, 2, 2],
  addDividendCubeToCenterPanel: ["stock-3d-cube", "dividend", "0 0 .5", "0.95 0.95 0.95", "Dividend", "30 0 0", 2, 2, 2],
  addDividendSectorCubeToCenterPanel: ["stock-3d-cube", "dividend-sec", "0 0 .5", "0.95 0.95 0.95", "Dividend by Sector", "30 0 0", 2, 2, 2],
  addShortInterestCubeToCenterPanel: ["stock-3d-cube", "sip", "0 0 .5", "0.95 0.95 0.95", "Short Interest Percentage", "30 0 0", 2, 2, 2],
  addShortInterestSectorCubeToCenterPanel: ["stock-3d-cube", "sip-sec", "0 0 .5", "0.95 0.95 0.95", "Short Interest Percentage by Sector", "30 0 0", 2, 2, 2],
  addWatchlistReportsCubeToCenterPanel: ["stock-3d-cube", "watchlist-reports", "0 0 .5", "0.95 0.95 0.95", "Watchlist Reports", "30 0 0", 2, 2, 2]
};

function createStockVisualizer(id, dataSource, position, scale, bannerText, rotation, width, height, depth) {
  const centerPanel = document.getElementById("large-center-panel");
  if (!centerPanel) {
    if (__LOG_ERROR__) AppLog.error("Center panel not found");
    return;
  }

  const centerPanelContent = document.getElementById("large-center-panel-content") || centerPanel;
  const sectorSelector = document.getElementById("sector-selector");
  const timelineSelector = document.getElementById("timeline");
  const volDataSources = ['top-vol-sec', 'top-vol', 'top-dollar-vol', 'top-dollar-vol-sec'];
  const dataInterval = getCacheItem('data-interval');

  const visualizerConfig = {
    dataSource,
    selector: sectorSelector ? "#sector-selector" : null,
    timelineEntity: timelineSelector ? "#timeline" : null,
    interval: dataInterval ? dataInterval.toLowerCase() : null,
    ...(volDataSources.includes(dataSource) && { timelineEntity: timelineSelector ? "#timeline" : null })
  };

  let stockCube = document.getElementById(id);
  let wrapper = document.getElementById(`${id}-wrapper`);

  if (!stockCube || !wrapper) {
    if (__LOG_WARN__) AppLog.warn("Create new wrapper and cube",visualizerConfig);

    wrapper = document.createElement("a-box");
    wrapper.setAttribute("id", `${id}-wrapper`);
    wrapper.setAttribute("width", width);
    wrapper.setAttribute("height", height);
    wrapper.setAttribute("depth", depth);
    wrapper.setAttribute("material", `opacity: 0; transparent: true; side: double;  depthTest: false`);
    wrapper.setAttribute("position", position);
    wrapper.setAttribute("rotation", rotation || "0 0 0");
    centerPanelContent.appendChild(wrapper);

    stockCube = document.createElement("a-box");
    stockCube.setAttribute("id", id);
    stockCube.setAttribute("position", "0 0 0");
    stockCube.setAttribute("stock-cube-visualizer", visualizerConfig);
    stockCube.setAttribute("scale", scale);
    stockCube.setAttribute("material", `opacity: 0; transparent: true; side: double;  depthTest: false`);
    stockCube.setAttribute("width", width);
    stockCube.setAttribute("height", height);
    stockCube.setAttribute("depth", depth);
    wrapper.appendChild(stockCube);

    if (sectorSelector) {
      sectorSelector.setAttribute("sector-selector", { target: stockCube });
    }
  } else {
    if (__LOG_WARN__) AppLog.warn("Update existing wrapper and cube",visualizerConfig);
    stockCube.setAttribute("stock-cube-visualizer", visualizerConfig);
    stockCube.setAttribute("position", "0 0 0");
    stockCube.setAttribute("scale", scale);
    stockCube.setAttribute("material", "wireframe: true; color: #fff");
    stockCube.setAttribute("width", width);
    stockCube.setAttribute("height", height);
    stockCube.setAttribute("depth", depth);
    if (wrapper) {
      wrapper.setAttribute("position", position);
      wrapper.setAttribute("rotation", rotation || "0 0 0");
      wrapper.setAttribute("scale", "1 1 1");
      if (wrapper.object3D) wrapper.object3D.scale.set(1, 1, 1);
    }
    if (sectorSelector) {
      sectorSelector.setAttribute("sector-selector", { target: stockCube });
    }
  }

  addBannerAndRotationControls(bannerText);

  const updateTimelineAttributes = () => {
    if (timelineSelector && timelineSelector.components && timelineSelector.components['timeline-control']) {
      const dataIntervalCache = getCacheItem('data-interval');
      const interval = (dataIntervalCache ? dataIntervalCache.toLowerCase() : null) || '1d';
      
      timelineSelector.setAttribute('timeline-control', {
        dataSource: dataSource,
        interval: interval
      });
      
      if (__LOG_INFO__) AppLog.info('[StockCubePlacements] Updated timeline with dataSource:', dataSource, 'interval:', interval);
    }
  };
  
  updateTimelineAttributes();
  
  const onStockDataLoaded = (event) => {
    const { dataSource: loadedDataSource } = event.detail || {};
    
    if (loadedDataSource === dataSource && timelineSelector) {
      const dataIntervalCache = getCacheItem('data-interval');
      const interval = (dataIntervalCache ? dataIntervalCache.toLowerCase() : null) || '1d';
      
      let previousCloseDate = '';
      
      if (stockCube && stockCube.components && stockCube.components['stock-cube-visualizer']) {
        const visualizer = stockCube.components['stock-cube-visualizer'];
        if (visualizer.currentData && visualizer.currentData.metadata && visualizer.currentData.metadata.previous_close_date) {
          previousCloseDate = visualizer.currentData.metadata.previous_close_date;
        }
      }
      
      timelineSelector.setAttribute('timeline-control', {
        dataSource: dataSource,
        interval: interval,
        previousCloseDate: previousCloseDate
      });
      
      if (__LOG_INFO__) AppLog.info('[StockCubePlacements] Stock data loaded - updated timeline with dataSource:', dataSource, 'interval:', interval, 'previousCloseDate:', previousCloseDate);
    }
  };
  
  document.addEventListener('stock-data-loaded', onStockDataLoaded);
}

if (typeof window !== 'undefined') {
  window.getBannerTextForDataSource = function(dataSource) {
    for (const key in stockVisualizations) {
      if (stockVisualizations[key][1] === dataSource) {
        return stockVisualizations[key][4];
      }
    }
    return '';
  };
  window.addBannerAndRotationControls = addBannerAndRotationControls;
  window.createStockVisualizer = createStockVisualizer;
  window.addStockGainersToCenterPanel = addStockGainersToCenterPanel;
  window.addStockLosersToCenterPanel = addStockLosersToCenterPanel;
  window.addStockGainersSectorToCenterPanel = addStockGainersSectorToCenterPanel;
  window.addStockLosersSectorToCenterPanel = addStockLosersSectorToCenterPanel;
  window.addStockByVolCubeToCenterPanel = addStockByVolCubeToCenterPanel;
  window.addStockByVolRankCubeToCenterPanel = addStockByVolRankCubeToCenterPanel;
  window.addStockTopDollarCubeToCenterPanel = addStockTopDollarCubeToCenterPanel;
  window.addStockTopDollarSectorCubeToCenterPanel = addStockTopDollarSectorCubeToCenterPanel;
  window.addMarketMapCubeToCenterPanel = addMarketMapCubeToCenterPanel;
  window.addDividendCubeToCenterPanel = addDividendCubeToCenterPanel;
  window.addDividendSectorCubeToCenterPanel = addDividendSectorCubeToCenterPanel;
  window.addShortInterestCubeToCenterPanel = addShortInterestCubeToCenterPanel;
  window.addShortInterestSectorCubeToCenterPanel = addShortInterestSectorCubeToCenterPanel;
  window.addWatchlistReportsCubeToCenterPanel = addWatchlistReportsCubeToCenterPanel;
  window.addStockChartToRightPanel = addStockChartToRightPanel;
}

function addStockGainersToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockGainersToCenterPanel);
  lastAddStockFunction = addStockGainersToCenterPanel;
}

function addStockLosersToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockLosersToCenterPanel);
  lastAddStockFunction = addStockLosersToCenterPanel;
}

function addStockGainersSectorToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockGainersSectorToCenterPanel);
  lastAddStockFunction = addStockGainersSectorToCenterPanel;
}

function addStockLosersSectorToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockLosersSectorToCenterPanel);
  lastAddStockFunction = addStockLosersSectorToCenterPanel;
}

function addStockByVolCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockByVolCubeToCenterPanel);
  lastAddStockFunction = addStockByVolCubeToCenterPanel;
}

function addStockByVolRankCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockByVolRankCubeToCenterPanel);
  lastAddStockFunction = addStockByVolRankCubeToCenterPanel;
}

function addStockTopDollarCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockTopDollarCubeToCenterPanel);
  lastAddStockFunction = addStockTopDollarCubeToCenterPanel;
}

function addStockTopDollarSectorCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addStockTopDollarSectorCubeToCenterPanel);
  lastAddStockFunction = addStockTopDollarSectorCubeToCenterPanel;
}

function addMarketMapCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addMarketMapCubeToCenterPanel);
  lastAddStockFunction = addMarketMapCubeToCenterPanel;
}

function addDividendCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addDividendCubeToCenterPanel);
  lastAddStockFunction = addDividendCubeToCenterPanel;
}

function addDividendSectorCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addDividendSectorCubeToCenterPanel);
  lastAddStockFunction = addDividendCubeToCenterPanel;
}

function addShortInterestCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addShortInterestCubeToCenterPanel);
  lastAddStockFunction = addShortInterestCubeToCenterPanel;
}

function addShortInterestSectorCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addShortInterestSectorCubeToCenterPanel);
  lastAddStockFunction = addShortInterestSectorCubeToCenterPanel;
}

function addWatchlistReportsCubeToCenterPanel() {
  createStockVisualizer(...stockVisualizations.addWatchlistReportsCubeToCenterPanel);
  lastAddStockFunction = addWatchlistReportsCubeToCenterPanel;
}

function addStockChartToRightPanel(stockSymbol) {
  const rightPanel = document.getElementById("large-right-panel");
  if (!rightPanel) {
    if (__LOG_ERROR__) AppLog.error("Right panel not found");
    return;
  }

  let stockChart = document.getElementById("stock-chart");
  if (stockChart) {
    stockChart.remove();
  }

  const newStockChart = document.createElement("a-entity");
  newStockChart.setAttribute("id", "stock-chart");
  newStockChart.setAttribute("position", "-1.5 -1 0");
  newStockChart.setAttribute("scale", "0.75 0.75 0.75");
  const chartComponent = document.createElement("a-entity");
  chartComponent.setAttribute("id", "stock-candlestick-chart");
  chartComponent.setAttribute("position", "0 0 0");
  chartComponent.setAttribute("stock-candlestick-chart", {
    intervals: 100,
    stockSymbol
  });

  const rightPanelContent = document.getElementById("large-right-panel-content");
  if (rightPanelContent) {
    newStockChart.appendChild(chartComponent);
    rightPanelContent.appendChild(newStockChart);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const scene = document.querySelector('a-scene');
  if (scene) {
    scene.addEventListener('app-state-changed', () => {
      if (lastAddStockFunction) {
        if (__LOG_INFO__) AppLog.info('App state changed, re-running:', lastAddStockFunction.name);
        lastAddStockFunction();
      } else {
        if (__LOG_WARN__) AppLog.warn('No last addStock function to re-run');
      }
    });
  } else {
    document.addEventListener('loaded', () => {
      const newScene = document.querySelector('a-scene');
      if (newScene) {
        newScene.addEventListener('app-state-changed', () => {
          if (lastAddStockFunction) {
            if (__LOG_INFO__) AppLog.info('App state changed, re-running:', lastAddStockFunction.name);
            lastAddStockFunction();
          } else {
            if (__LOG_WARN__) AppLog.warn('No last addStock function to re-run');
          }
        });
      }
    }, { once: true });
  }
});
